import {ROUTES} from '../../constants/routing'
import {AttributeModel} from '../model/AttributeModel'
import {useDatxPathGenerator} from '../../util/routing'
import {Link} from 'react-router-dom'
import {ComplexAttribute} from './ComplexAttribute'
import React from 'react'

export const OrganizationLinkAttribute = ({attribute}: { attribute: AttributeModel }) => {
    const linkedOrganization = attribute.value.linkedOrganization
    const generatePath = useDatxPathGenerator()

    if (!linkedOrganization) return null

    return <ComplexAttribute attribute={attribute}>
        <div className="organization-link-attribute">
            <Link
                to={generatePath(ROUTES.organizationDetails.path, {organizationId: linkedOrganization.id})}
                data-testid={`organization-${linkedOrganization.id}`}>
                {linkedOrganization.label}
            </Link>
            <span
                className="cell linked-organization-codification">{linkedOrganization.codificationSystem}</span>
            <span className="cell linked-organization-code">{linkedOrganization.code}</span>
        </div>
    </ComplexAttribute>
}
